// 分账管理相关 API

import request, { get, post, put, del } from '@/api/request'

/**
 * 分账规则相关 API
 */

// 获取分账规则列表
export function getCommissionRuleList(params) {
  return get('/commission/rule', params)
}

// 分页查询分账规则
export function getCommissionRulePage(params) {
  return get('/commission/rule/page', params)
}

// 获取分账规则详情
export function getCommissionRule(id) {
  return get(`/commission/rule/${id}`)
}

// 创建分账规则
export function createCommissionRule(data) {
  return post('/commission/rule', data)
}

// 更新分账规则
export function updateCommissionRule(id, data) {
  return put(`/commission/rule/${id}`, data)
}

// 删除分账规则
export function deleteCommissionRule(id) {
  return del(`/commission/rule/${id}`)
}

// 启用分账规则
export function enableCommissionRule(id) {
  return put(`/commission/rule/${id}/enable`)
}

// 更新规则优先级
export function updateCommissionRulePriority(id, priority) {
  return put(`/commission/rule/${id}/priority`, { priority })
}

/**
 * 分账记录相关 API
 */

// 获取结算单列表
export function getCommissionSettlementPage(params) {
  return get('/commission/settlement/page', params)
}

// 获取结算单详情
export function getCommissionSettlementDetail(id) {
  return get(`/commission/settlement/${id}`)
}

// 重试分账记录
export function retryCommissionRecord(id) {
  return post(`/commission/record/${id}/retry`)
}

// 导出分账记录
export function exportCommissionRecord(id) {
  return get(`/commission/record/${id}/export`, null, { responseType: 'blob' })
}

/**
 * 引入人账户相关 API
 */

// 获取引入人账户详情
export function getReferrerAccount(referrerId) {
  return get(`/commission/referrer-account/${referrerId}`)
}

// 获取引入人流水列表
export function getReferrerFlowList(referrerId, params) {
  return post(`/commission/referrer-account/${referrerId}/flows`, params)
}

// 查询银行账户列表
export function getBankAccountList(params) {
  return post('/commission/bank-account/list', params)
}

// 创建银行账户
export function createBankAccount(data) {
  return post('/commission/bank-account', data)
}

// 更新银行账户
export function updateBankAccount(data) {
  return put('/commission/bank-account', data)
}

// 设置默认账户
export function setDefaultBankAccount(id) {
  return put(`/commission/bank-account/${id}/default`)
}

// 删除银行账户
export function deleteBankAccount(id) {
  return del(`/commission/bank-account/${id}`)
}

/**
 * 引入人拉卡拉分账接收方账户相关 API
 */

// 查询引入人拉卡拉分账接收方账户
export function getReferrerLakalaReceiver(referrerId) {
  return get(`/commission/referrer-account/${referrerId}/lakala-receiver`)
}

// 创建引入人拉卡拉分账接收方账户
export function createReferrerLakalaReceiver(data) {
  return post('/commission/referrer-account/lakala-receiver', data)
}

// 更新引入人拉卡拉分账接收方账户
export function updateReferrerLakalaReceiver(data) {
  return put('/commission/referrer-account/lakala-receiver', data)
}

/**
 * 平台拉卡拉分账接收方账户相关 API
 */

// 查询加盟商维度平台拉卡拉分账接收方账户
export function getFranchiseePlatformLakalaReceiver(franchiseeId) {
  return get(`/franchisee/${franchiseeId}/platform-lakala-receiver`)
}

// 创建加盟商维度平台拉卡拉分账接收方账户
export function createFranchiseePlatformLakalaReceiver(franchiseeId, data) {
  return post(`/franchisee/${franchiseeId}/platform-lakala-receiver`, data)
}

// 更新加盟商维度平台拉卡拉分账接收方账户
export function updateFranchiseePlatformLakalaReceiver(franchiseeId, data) {
  return put(`/franchisee/${franchiseeId}/platform-lakala-receiver`, data)
}

/**
 * 上传佣金业务拉卡拉附件
 * @param {FormData} formData - FormData对象，包含 referrerId 或 tenantId、attType、file、remark、bucket、module
 */
export function uploadCommissionLakalaFile(formData) {
  return request.post('/commission/lakala-files', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 创建引入人与默认加盟商分账绑定
export function createDefaultReferrerFranchiseeBind(referrerId, data) {
  return post(`/commission/referrer-account/${referrerId}/default-franchisee-bind`, data)
}

// 查询引入人与默认加盟商分账绑定
export function getDefaultReferrerFranchiseeBind(referrerId) {
  return get(`/commission/referrer-account/${referrerId}/default-franchisee-bind`)
}

/**
 * 加盟商分账账户相关 API
 */

// 查询加盟商分账账户
export function getFranchiseeAccount(franchiseeId) {
  return get(`/franchisee/${franchiseeId}/account`)
}

// 创建加盟商分账账户
export function createFranchiseeAccount(data) {
  return post('/franchisee/account', data)
}

// 更新加盟商分账账户
export function updateFranchiseeAccount(data) {
  return put('/franchisee/account', data)
}

// 绑定加盟商分账账户与平台接收方
export function bindFranchiseePlatformReceiver(franchiseeId, data) {
  return post(`/franchisee/${franchiseeId}/account/platform-receiver-bind`, data)
}

/**
 * 上传加盟商开户所需拉卡拉附件
 * @param {FormData} formData - FormData对象，包含 attType, file, remark, bucket, module
 * @param {string} formData.attType - 附件类型
 * @param {File} formData.file - 文件
 * @param {string} [formData.remark] - 备注
 * @param {string} [formData.bucket] - OSS桶
 * @param {string} [formData.module] - 业务模块
 */
export function uploadLakalaFile(formData) {
  return request.post('/franchisee/account/lakala-file', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

/**
 * 提现管理相关 API
 */

/**
 * 分页查询提现订单
 * @param {Object} params - 查询参数
 * @param {number} params.pageNum - 当前页码
 * @param {number} params.pageSize - 每页大小
 * @param {number} [params.referrerId] - 引入人ID
 * @param {number} [params.status] - 状态：0-待审核，1-待打款，3-已到账，4-已驳回
 * @param {string} [params.startDate] - 开始时间
 * @param {string} [params.endDate] - 结束时间
 */
export function getWithdrawOrderList(params) {
  return post('/commission/withdraw/list', params)
}

/**
 * 获取提现订单详情
 * @param {number} id - 订单ID
 */
export function getWithdrawOrderDetail(id) {
  return get(`/commission/withdraw/${id}`)
}

/**
 * 获取提现订单完整详情，包含来源账单、处理进度和资金流水
 * @param {number} id - 订单ID
 */
export function getWithdrawOrderFullDetail(id) {
  return get(`/commission/withdraw/${id}/detail`)
}

/**
 * 查询可提现账单明细
 * @param {Object} data - 查询参数
 */
export function listAvailableWithdrawDetails(data) {
  return post('/commission/withdraw/available-details', data)
}

/**
 * 发起提现申请
 * @param {Object} data - 提现数据
 * @param {number} data.referrerId - 引入人ID
 * @param {number} data.amount - 提现金额
 * @param {number[]} [data.detailIds] - 关联的分账明细ID列表
 * @param {string} [data.remark] - 备注
 * @param {boolean} [data.requireAudit] - 是否需要审核
 */
export function createWithdraw(data) {
  return post('/commission/withdraw', data)
}

/**
 * 按账单明细发起提现申请
 * @param {Object} data - 提现数据
 * @param {number} data.referrerId - 引入人ID
 * @param {number[]} data.commissionDetailIds - 分账明细ID列表
 * @param {number} data.expectedAmount - 前端确认的提现总金额
 * @param {string} [data.remark] - 备注
 * @param {boolean} [data.requireAudit] - 是否需要审核
 */
export function createWithdrawByDetails(data) {
  return post('/commission/withdraw/by-details', data)
}

/**
 * 审核提现订单
 * @param {Object} data - 审核数据
 * @param {number[]} data.withdrawOrderIds - 提现订单ID列表
 * @param {string} data.action - 审核操作：APPROVE-通过，REJECT-驳回
 * @param {string} [data.auditRemark] - 审核备注
 * @param {string} [data.rejectReason] - 驳回原因
 */
export function auditWithdraw(data) {
  return post('/commission/withdraw/audit', data)
}

/**
 * 分页查询待人工处理提现单
 * @param {Object} data - 查询参数
 */
export function listManualHandleWithdrawOrders(data) {
  return post('/commission/withdraw/manual-handle/list', data)
}

/**
 * 完成人工处理提现单
 * @param {Object} data - 处理参数
 * @param {number} data.withdrawOrderId - 提现订单ID
 * @param {string} [data.remark] - 处理备注
 */
export function completeManualWithdraw(data) {
  return post('/commission/withdraw/manual-handle/complete', data)
}

/**
 * 触发提现超时处理
 */
export function handleWithdrawTimeoutOrders() {
  return post('/commission/withdraw/handle-timeout')
}

/**
 * 取消提现订单
 * @param {number} id - 提现订单ID
 * @param {string} reason - 取消原因
 */
export function cancelWithdraw(id, reason) {
  return request.post(`/commission/withdraw/${id}/cancel`, null, { params: { reason } })
}

/**
 * 获取用户可提现余额
 * @param {number} referrerId - 引入人ID
 */
export function getWithdrawableBalance(referrerId) {
  return get('/commission/withdraw/balance', { referrerId })
}

/**
 * 获取用户银行账户列表
 * @param {number} referrerId - 引入人ID
 */
export function getWithdrawAccountList(referrerId) {
  return get('/commission/withdraw/accounts', { referrerId })
}
